export default __webpack_public_path__ + "static/media/barefoot-trek.2e36c626.jpg";